<template>
  
  <div class="formBuffet">
    <div>
      <h1>Solicitação de Buffet</h1>
      <br />
      <button @click="goHome()">Voltar</button>
      <br /> <br />
    </div>

    <!--Dados do Responsável pela solicitacao -->
    <div id="dados-responsavel-viagem">
      <h2>Dados Gerais da Solicitação</h2>
      <br />
      <label for="tituloEvento" class="required">Título do Evento:</label>
      <input id="tituloEvento" v-model="solicitacao.tituloEvento" type="text" required/>

      <br />
      <label for="justificativaSolicitacao" class="required">Justificativa da Solicitação:</label>
      <input id="justificativaSolicitacao" v-model="solicitacao.justificativaSolicitacao" type="text" maxlength="100" required/>

      <br />
      <label for="dataEvento" class="required">Dia do Evento:</label>
      <input id="dataEvento" v-model="solicitacao.dataEvento" type="date" :min="this.dataMinima" @blur="validarData"
      />

      <br />
      <label for="horarioEvento" class="required">Horário para Início do Buffet:</label>
      <input id="horarioEvento" v-model="solicitacao.horarioEvento" type="time" min="07:00" max="20:00" />

      <br />
      <label for="localEvento" class="required">Local do Evento:</label>
      <select id="localEvento" v-model="solicitacao.localEvento">
        <option value="Campus da Cidade Universitária “Zeferino Vaz”">Campus da Cidade Universitária “Zeferino Vaz”</option>
        <option value="Moradia Estudantil">Moradia Estudantil</option>
        <option value="LUME Teatro">LUME Teatro</option>
        <option value="Colégio Técnico de Campinas – COTUCA">Colégio Técnico de Campinas – COTUCA</option>
        <option value="CIS-GUANABARA">CIS-GUANABARA</option>
        <option value="CPQBA">CPQBA</option>
        
      </select>

      <br />
      <label for="enderecoEvento" class="required">Endereço:</label>
      <input id="enderecoEvento" v-model="solicitacao.endereco" type="text" required/>

      <br />
      <label for="complementoEvento" class="required">Complemento:</label>
      <input id="complementoEvento" v-model="solicitacao.complemento" type="text" required placeholder="faculdade/instituto/prédio/sala"/>

      <br />
      <label for="qtdePessoas" class="required">Quantidade de Pessoas a Serem Atendidas:</label>
      <input id="qtdePessoas" v-model="solicitacao.qtdePessoas" type="number" :min="20" required>
      
      <br />
      <label for="servidorResponsavel" class="required">Servidor Responsável pela Fiscalização:</label>
      <input id="servidorResponsavel" v-model="solicitacao.servidorResponsavel" type="text" required />

      <br />
      <label for="matriculaServidorResponsavel" class="required">Matrícula do Servidor Responsável:</label>
      <input id="matriculaServidorResponsavel" v-maskMatricula v-model="solicitacao.matriculaServidorResponsavel" type="text" maxlength="6" placeholder="000000" required/>

      <br />
      <label for="emailServidorResponsavel" class="required">E-mail do Servidor Responsável:</label>
      <input id="emailServidorResponsavel" v-model="solicitacao.emailServidorResponsavel" type="text" required/>

      <br />
      <label for="telefoneServidorResponsavel" class="required">Telefone do Servidor Responsável:</label>
      <input id="telefoneServidorResponsavel" v-maskTelefone v-model="solicitacao.telefoneServidorResponsavel" type="text" placeholder="(00) 00000-0000" required/>


      <br />
      <label for="numeroSEC" class="required">Número da SEC:</label>
      <!-- <InputMask id="numeroSEC" v-model="solicitacao.numeroSEC" mask="99999/9999" placeholder="00000/0000" required/> -->
      <input id="numeroSEC" v-maskNumeroSEC v-model="solicitacao.numeroSEC" type="text" maxlength="10" placeholder="00000/0000" required />


      <!-- div para receber as mensagens de erro-->
      <div v-if="errosDadosGerais.length" class="error-messages">
        <ul>
          <li v-for="(erro, index) in errosDadosGerais" :key="index">{{ erro }}</li>
        </ul>
      </div>

      <div>
      <br />
      <button @click="continuar()" style="display: block; margin: 0 auto;">Continuar</button>
    </div>
    </div>

    <!--Dados Da Solicitação-->
    <br /><br />
    <div id="dados-gerais-viagem" v-if="this.isContinuar"> 
      <h2>Cardápio</h2>

      <br />
      <label for="tipoBuffet" class="required">Tipo de Buffet:</label>
      <select id="tipoBuffet" v-model="solicitacao.tipoBuffet" @change="this.handleChangeTipoBuffet">
        <option value="Coffee Break Tipo 1">Coffee Break Tipo 1</option>
        <option value="Coffee Break Tipo 2">Coffee Break Tipo 2</option>
        <option value="Coffee Break Tipo 3">Coffee Break Tipo 3</option>
        <option value="Brunch">Brunch</option>
        <option value="Kit Lanche">Kit Lanche</option>
      </select>

      <div id="valorDoBuffet" v-if="this.valorPorPessoa != null">
        Valor por pessoa: {{  this.valorPorPessoaFormatado }} <br />
        Valor da solicitação: {{  this.valoDaSolicitacaoFormatado }}
        <br /><br />
        <div class="instrucoes">
          Prossiga com o preenchimento da SEC no Portal SIAD
        </div>
      </div>


      <CoffeeBreakT1 :key="cardapioKey" v-if="this.solicitacao.tipoBuffet === 'Coffee Break Tipo 1'" @atualizar-cardapio="receberEmitCardapio" />
      <CoffeeBreakT2 :key="cardapioKey" v-if="this.solicitacao.tipoBuffet === 'Coffee Break Tipo 2'" @atualizar-cardapio="receberEmitCardapio" />
      <CoffeeBreakT3 :key="cardapioKey" v-if="this.solicitacao.tipoBuffet === 'Coffee Break Tipo 3'" @atualizar-cardapio="receberEmitCardapio" />
      <Brunch :key="cardapioKey" v-if="this.solicitacao.tipoBuffet === 'Brunch'" @atualizar-cardapio="receberEmitCardapio" />
      <KitLanche :key="cardapioKey" v-if="this.solicitacao.tipoBuffet === 'Kit Lanche'" @atualizar-cardapio="receberEmitCardapio" />
      

      <br />
      <br />

      <!-- div para receber as mensagens de erro-->
      <div v-if="errosDadosCardapio.length" class="error-messages">
        <ul>
          <li v-for="(erro, index) in errosDadosCardapio" :key="index">{{ erro }}</li>
        </ul>
      </div>
    </div>

    <br />

    <div v-if="this.solicitacao.tipoBuffet">
       <label style="width: auto;"> 
        <input type="checkbox" v-model="isConfirmado" style="width: auto;"/>
        Confirmo que todos os dados informados estão corretos
      </label> 
    </div>

    <div>
      <br />
      <button @click="enviarSolicitacao()" style="display: block; margin: 0 auto;" v-if="this.solicitacao.tipoBuffet">Enviar solicitação</button>
    </div>
  </div>

</template>

<script src="@/service/BuffetPage.js"></script>

<style src="../css/buffet.css"></style>